import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { FormattedMessage } from 'react-intl';
import Button from '@material-ui/core/Button';
import Dialog from '@afosto/app-components-react/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import LoadingWrapper from '@afosto/components-react/LoadingWrapper';
import translations from './translations';

const ParcelsDialog = ({
  allowCreate,
  isLoading,
  isOpen,
  onClose,
  onCreate,
  onSelect,
  parcels,
  parcelQuantities,
  selectedParcel,
}) => {
  const intl = useIntl();

  const handleSelectParcel = parcel => {
    if (onSelect && typeof onSelect === 'function') {
      onSelect(parcel);
    }
  };

  const handleCreateParcel = () => {
    if (onCreate && typeof onCreate === 'function') {
      onCreate();
    }
  };

  const getItemTotal = parcel => parcelQuantities?.[parcel.id] ?? parcel?.items?.length ?? 0;

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="xs" disableRestoreFocus>
      <DialogTitle>
        <FormattedMessage {...translations.title} />
      </DialogTitle>
      <LoadingWrapper isLoading={isLoading}>
        <List style={{ minWidth: 300 }}>
          {parcels.length > 0 && <Divider />}
          {parcels.map(parcel => {
            const isSelected = selectedParcel?.id === parcel.id;

            return (
              <ListItem
                key={parcel.id}
                button
                onClick={() => handleSelectParcel(parcel)}
                selected={isSelected}
              >
                <ListItemText
                  primary={parcel.number}
                  secondary={intl.formatMessage(translations.numberOfItems, {
                    count: getItemTotal(parcel),
                  })}
                />
              </ListItem>
            );
          })}
        </List>
      </LoadingWrapper>
      <DialogActions>
        <Button
          variant="outlined"
          onClick={onClose}
          style={{ marginRight: 'auto' }}
          disabled={isLoading}
        >
          <FormattedMessage {...translations.buttons.close} />
        </Button>
        <Button
          color="primary"
          variant="outlined"
          onClick={() => handleCreateParcel()}
          disabled={isLoading || !allowCreate}
        >
          <FormattedMessage {...translations.buttons.createParcel} />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ParcelsDialog.propTypes = {
  allowCreate: PropTypes.bool,
  isLoading: PropTypes.bool,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onCreate: PropTypes.func,
  onSelect: PropTypes.func,
  parcels: PropTypes.array,
  parcelQuantities: PropTypes.object,
  selectedParcel: PropTypes.object,
};

ParcelsDialog.defaultProps = {
  allowCreate: true,
  isLoading: false,
  isOpen: false,
  onClose: undefined,
  onCreate: undefined,
  onSelect: undefined,
  parcels: [],
  parcelQuantities: {},
  selectedParcel: undefined,
};

export default ParcelsDialog;
